import { Routes } from '@angular/router';
import { AuthGuard } from '../utilities/guards/auth.guard';
import { PermissionGuard } from '../utilities/guards/permission.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./account/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'profile',
    loadComponent: () => import('./account/profile/profile.page').then((m) => m.ProfilePage),
    canActivate: [AuthGuard] // Requiere autenticación y verifica integridad
  },
  {
    path: 'home',
    loadComponent: () => import('./home/home.page').then((m) => m.HomePage),
    canActivate: [AuthGuard] // Requiere autenticación y verifica integridad
  },
  {
    path: 'home/start-vehicle-use',
    loadComponent: () => import('./home/start-vehicle-use/start-vehicle-use.page').then((m) => m.StartVehicleUsePage),
    canActivate: [AuthGuard] // Requiere autenticación
  },
  {
    path: 'home/start-courtesy-use',
    loadComponent: () => import('./home/start-courtesy-use/start-courtesy-use.page').then((m) => m.StartCourtesyUsePage),
    canActivate: [AuthGuard],
  },
  {
    path: 'home/vehicle-details',
    loadComponent: () => import('./home/vehicle-details/vehicle-details.page').then((m) => m.VehicleDetailsPage),
    canActivate: [AuthGuard] // Requiere autenticación
  },
  {
    path: 'home/end-vehicle-use',
    loadComponent: () => import('./home/end-vehicle-use/end-vehicle-use.page').then((m) => m.EndVehicleUsePage),
    canActivate: [AuthGuard] // Requiere autenticación
  },
  {
    path: 'home/return-vehicle',
    loadComponent: () => import('./home/return-vehicle/return-vehicle.page').then((m) => m.ReturnVehiclePage),
    canActivate: [AuthGuard] // Requiere autenticación
  },
  {
    path: 'home/return-courtesy-vehicle',
    loadComponent: () =>
      import('./home/return-courtesy-vehicle/return-courtesy-vehicle.page').then(
        (m) => m.ReturnCourtesyVehiclePage,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'home/end-courtesy-vehicle-use',
    loadComponent: () =>
      import('./home/end-courtesy-vehicle-use/end-courtesy-vehicle-use.page').then(
        (m) => m.EndCourtesyVehicleUsePage,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'home/deliver-courtesy-vehicle',
    loadComponent: () =>
      import('./home/deliver-courtesy-vehicle/deliver-courtesy-vehicle.page').then(
        (m) => m.DeliverCourtesyVehiclePage,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'home/courtesy-delivery',
    loadComponent: () =>
      import('./home/deliver-courtesy-vehicle/courtesy-delivery.page').then(
        (m) => m.CourtesyDeliveryPage,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'home/start-courtesy-internal-use',
    loadComponent: () =>
      import('./home/courtesy-internal-use/start-courtesy-internal-use.page').then(
        (m) => m.StartCourtesyInternalUsePage,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'home/return-courtesy-internal-use',
    loadComponent: () =>
      import('./home/courtesy-internal-use/return-courtesy-internal-use.page').then(
        (m) => m.ReturnCourtesyInternalUsePage,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'home/pending-courtesy-uses',
    loadComponent: () =>
      import('./home/pending-courtesy-uses/pending-courtesy-uses.page').then(
        (m) => m.PendingCourtesyUsesPage,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'vehicles',
    loadComponent: () => import('./home/vehicles/vehicles.page').then( m => m.VehiclesPage),
    canActivate: [AuthGuard, PermissionGuard], // Requiere autenticación y permisos
    data: { 
      permissions: ['VehicleController.findAll'],
      requireAllPermissions: false 
    }
  },
  {
    path: 'unauthorized',
    loadComponent: () => import('./shared/unauthorized/unauthorized.page').then(m => m.UnauthorizedPage)
  }
];

